import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { Icon } from 'antd';

const StyledIcon = styled.i<{ hoverColor: string; disabled: boolean }>`
  color: ${props => (props.disabled ? 'rgba(97, 104, 129, 0.3)' : '#616881')};
  &:hover {
    color: ${props =>
      props.disabled ? 'rgba(97, 104, 129, 0.3)' : props.hoverColor};
  }
`;

interface IconProps {
  type: string;
  style?: CSSProperties;
  disabled?: boolean;
}

export const IconFont = Icon.createFromIconfontCN({
  scriptUrl: 'https://at.alicdn.com/t/font_1361446_vaucd8l2ac8.js',
});

// alo7项目中用到的icon全都封装到这里。图标用的都是iconfont里的图标， 用的classFont
// 用type来区分不同的图标类型
export function Alo7Icon(props: IconProps) {
  const { type, style, disabled } = props;
  let className = 'iconfont ';
  let hoverColor = '#616881';
  switch (type) {
    case 'edit':
      className += 'iconbianji1';
      hoverColor = '#1CC5A5';
      break;
    case 'publish':
      className += 'iconfabu1';
      hoverColor = '#64C9FD';
      break;
    case 'audit':
      className += 'iconshenhe';
      break;
    case 'move':
      className += 'iconcaozuojiemiantubiao--_yidong';
      break;
    case 'preview':
      className += 'iconyulan';
      break;
    case 'takeoff':
      className += 'iconxiajia';
      hoverColor = '#FE6360';
      break;
    case 'back':
      className += 'iconback';
      break;
    case 'delete':
      className += 'iconshanchu';
      hoverColor = '#ff9913';
      break;
    default:
      return <Icon style={style} type={type} />;
  }
  return (
    <StyledIcon
      className={className}
      style={style}
      hoverColor={hoverColor}
      disabled={disabled}
    />
  );
}
